import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';
import type { AppSettingsResponse } from '@app/interfaces/setting';

const url = `/api/app_settings`;

export const getAppSettingsApi = async (): Promise<AppSettingsResponse | undefined> => {
  try {
    const response = await axiosApi.get<AppSettingsResponse>(url);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

/**
 * Whitelist hiển thị (logo, tên shop, currency, onepay_enable...) — mọi user
 * đã đăng nhập đều đọc được. AppSettingContext dùng API này thay cho
 * getAppSettingsApi (endpoint đầy đủ chỉ dành cho admin, user thường bị 403).
 */
export const getPublicAppSettingsApi = async (): Promise<AppSettingsResponse | undefined> => {
  try {
    const response = await axiosApi.get<AppSettingsResponse>(`${url}/public_settings`);
    return response.data;
  } catch {
    // Gọi nền lúc vào app — lỗi thì dùng giá trị mặc định, không toast
    return undefined;
  }
};

/**
 * PATCH map key→value: chỉ gửi các key thay đổi (key vắng mặt = giữ nguyên).
 * Key bí mật là write-only — response luôn masked, không bao giờ echo secret.
 */
export const updateAppSettingsApi = async (data: Record<string, string>): Promise<AppSettingsResponse | undefined> => {
  try {
    const response = await axiosApi.patch<AppSettingsResponse>(url, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const uploadLogoApi = async (file: File): Promise<{ logo_url: string } | undefined> => {
  try {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await axiosApi.post(`${url}/upload_logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
